import React, { Component } from "react";
import { connect } from "react-redux";
import { applyDiscount } from "../../../redux/actions/Cart.Action";
import { withRouter } from "react-router-dom";
import { Modal } from "react-bootstrap";
import ApiConnect from "../../../Utils/ApiConnect";
import { toast } from "react-toastify";
class DiscountTotal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalModal: false,
      disModal: false,
      disMethod: "amount",
      disValue: this.props.CurrentCart
        ? this.props.CurrentCart.discount
          ? this.props.CurrentCart.discount.code
          : 0
        : 0 || 0,
    };
  }
  DiscountCart(e) {
    e.preventDefault();
    if (this.props.CurrentCart.length === 0) {
      toast.error("Please select the table", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        draggableDirection: "y",
      });
    } else {
      let reffCode = 0;
      let perCent = 0;
      let discountAmount = 0;
      let disMessage = "";
      switch (this.state.disMethod) {
        case "amount":
          this.ApplyMyDiscount(
            parseFloat(this.state.disValue),
            perCent,
            disMessage,
            reffCode
          );
          break;
        case "percentage":
          this.ApplyMyDiscount(
            discountAmount,
            parseFloat(this.state.disValue),
            disMessage,
            reffCode
          );
          break;
        case "code":
          this.FetchDetails("code");
          break;
        case "membership":
          this.FetchDetails("member");
          break;
        default:
          break;
      }
    }
  }
  ApplyMyDiscount(discountAmount, perCent, disMessage, reffCode) {
    this.props.applyDiscount(
      this.state.disMethod,
      discountAmount,
      perCent,
      disMessage,
      reffCode
    );
    this.setState({});
  }
  FetchDetails(action) {
    ApiConnect.get(
      `/POS/Checkout/DiscountOffer?${action}=${this.state.disValue}`
    )
      .then((response) => {
        if (response.data.status === 200) {
          const resp = response.data.data;

          this.ApplyMyDiscount(
            resp.amount,
            resp.percentage,
            resp.message,
            this.state.disValue
          );
        }
      })
      .catch((error) => console.log(error));
  }
  render() {
    const CurrentCart = this.props.CurrentCart;
    return (
      <>
        <div className="row">
          <div
            className="col-6"
            onClick={() => {
              if (this.props.POS && !this.props.lockScreen) {
                this.setState({ disModal: true });
              }
            }}
          >
            <div className="cart d-flex align-items-center">
              <span className="material-icons-outlined icon">percent</span>
              <div>
                <span className="subtitle">Discount:</span>
                <span className="title">
                  {CurrentCart.discount
                    ? `${
                        CurrentCart.discount.percentage > 0
                          ? `${CurrentCart.discount.percentage}%off`
                          : CurrentCart.discount.amount
                      }`
                    : " 0"}
                </span>
              </div>
            </div>
          </div>
          <div
            className="col-6"
            onClick={() => this.setState({ totalModal: true })}
          >
            <div className="cart d-flex align-items-center">
              <span className="material-icons-outlined icon">receipt_long</span>
              <div>
                <span className="subtitle">Total:</span>
                <span className="title">
                  {CurrentCart ? CurrentCart.total : ""}
                </span>
              </div>
            </div>
          </div>
        </div>
        <Modal
          show={this.state.disModal}
          className="modal-center"
          onHide={() => this.setState({ disModal: false })}
        >
          <Modal.Header className="mb-0 pb-0">
            <h5 className="modal-title">Discount</h5>
            <div className="d-flex justify-content-end p-1">
              <span
                className="fs-40 material-icons-outlined"
                onClick={() => this.setState({ disModal: false })}
              >
                close
              </span>
            </div>
          </Modal.Header>
          <Modal.Body className="">
            <div className="row">
              <div className="form-group col-md-6">
                <label className="text-fader">Method</label>
                <select
                  className="btn-group bootstrap-select form-control form-control-sm"
                  onChange={(e) => this.setState({ disMethod: e.target.value })}
                  defaultValue={
                    CurrentCart.discount ? CurrentCart.discount : ""
                  }
                >
                  <option value="amount">Amount</option>
                  <option value="percentage">Percentage</option>
                  <option value="code">Promo Code</option>
                  <option value="membership">Membership</option>
                </select>
              </div>
              <div className="form-group col-md-6">
                <label className="text-fader">Discount Value</label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    name="discount"
                    onChange={(e) =>
                      this.setState({ disValue: e.target.value })
                    }
                    defaultValue={this.state.disValue}
                  />
                  <div className="input-group-append">
                    <div className="btn-group">
                      <button
                        type="button"
                        className="btn btn-info"
                        onClick={(e) => this.DiscountCart(e)}
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.totalModal}
          className="modal-center"
          onHide={() => this.setState({ totalModal: false })}
        >
          <Modal.Header className="mb-0 pb-0">
            <h5 className="modal-title">
              Total {CurrentCart ? this.props.CurrentCart.total : 0}
            </h5>
            <div className="d-flex justify-content-end p-1">
              <span
                className="fs-40 material-icons-outlined"
                onClick={() => this.setState({ totalModal: false })}
              >
                close
              </span>
            </div>
          </Modal.Header>
          <Modal.Body className="">
            <table className="table table-borderless">
              <tbody>
                <tr className="d-flex col-12">
                  <td className="col">Sub total</td>
                  <td className="col text-right">
                    {" "}
                    रु {CurrentCart ? this.props.CurrentCart.subtotal : 0}
                  </td>
                  <td className="col text-right">
                    Tax{" "}
                    <small>
                      {CurrentCart
                        ? this.props.CurrentCart.tax
                          ? CurrentCart.tax_per
                          : 0
                        : 0}
                      %
                    </small>
                  </td>
                  <td className="col text-right">
                    रु {CurrentCart ? this.props.CurrentCart.tax : 0}
                  </td>
                </tr>

                <tr className="d-flex col-12">
                  <td className="col text-right">
                    S.Charge{" "}
                    <small>
                      {CurrentCart ? this.props.CurrentCart.service : 0}%
                    </small>
                  </td>
                  <td className="col text-right">
                    {" "}
                    रु {CurrentCart ? this.props.CurrentCart.charge : 0}
                  </td>
                  <td className="col">
                    Discount{" "}
                    <small>
                      {CurrentCart
                        ? CurrentCart.discount
                          ? this.props.CurrentCart.discount.percentage
                          : 0
                        : 0}
                      %
                    </small>
                  </td>
                  <td className="col text-right">
                    रु{" "}
                    {CurrentCart
                      ? CurrentCart.discount
                        ? this.props.CurrentCart.discount.amount
                        : 0
                      : 0}{" "}
                  </td>
                </tr>
                <tr>
                  <h6>
                    Total {CurrentCart ? this.props.CurrentCart.total : 0}
                  </h6>
                </tr>
              </tbody>
            </table>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default connect(
  (state) => ({
    CurrentCart: state.Cart.CurrentCart,
    LockScreen: state.Auth.lockScreen,
  }),
  { applyDiscount }
)(withRouter(React.memo(DiscountTotal)));
